// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! normalize.css v3.0.2 | MIT License | git.io/normalize */

/**
* 1. Set default font family to sans-serif.
* 2. Prevent iOS text size adjust after orientation change, without disabling
*    user zoom.
*/

@font-face {
    font-family: monospace;
    font-style: italic;
    font-weight: 400;
    src: local("Menlo Italic"),local(Menlo-Italic),local("Consolas Italic"),local(Consolas-Italic),local("Courier New Italic");
}

@font-face {
    font-family: monospace;
    font-style: italic;
    font-weight: 700;
    src: local("Menlo Bold Italic"),local(Menlo-BoldItalic),local(Monaco),local("Consolas Bold Italic"),local(Consolas-BoldItalic),local("Courier New Bold Italic");
}

@font-face {
    font-family: monospace;
    font-style: normal;
    font-weight: 400;
    src: local("Menlo Regular"),local(Menlo-Regular),local(Monaco),local(Consolas),local("Courier New");
}

@font-face {
    font-family: monospace;
    font-style: normal;
    font-weight: 700;
    src: local("Menlo Bold"),local(Menlo-Bold),local(Monaco),local("Consolas Bold"),local(Consolas-Bold),local("Courier New Bold");
}

@font-face {
    font-family: sans-serif;
    font-style: italic;
    font-weight: 300;
    src: local("Helvetica Neue Light Italic"),local(HelveticaNeue-LightItalic),local("Helvetica Light Oblique"),local(Helvetica-LightOblique);
}

@font-face {
    font-family: sans-serif;
    font-style: italic;
    font-weight: 400;
    src: local("Helvetica Neue Italic"),local(HelveticaNeue-Italic),local("Helvetica Oblique"),local(Helvetica-Oblique);
}

@font-face {
    font-family: sans-serif;
    font-style: italic;
    font-weight: 700;
    src: local("Helvetica Neue Bold Italic"),local(HelveticaNeue-BoldItalic),local("Helvetica Bold Oblique"),local(Helvetica-BoldOblique);
}

@font-face {
    font-family: sans-serif;
    font-style: normal;
    font-weight: 300;
    src: local("Helvetica Neue Light"),local(HelveticaNeue-Light),local("Helvetica Light"),local(Helvetica-Light);
}

@font-face {
    font-family: sans-serif;
    font-style: normal;
    font-weight: 400;
    src: local(HelveticaNeue),local(Helvetica);
}

@font-face {
    font-family: sans-serif;
    font-style: normal;
    font-weight: 700;
    src: local("Helvetica Neue Bold"),local(HelveticaNeue-Bold),local("Helvetica Bold"),local(Helvetica-Bold);
}

html {
    font-family: sans-serif; /* 1 */
    -ms-text-size-adjust: 100%; /* 2 */
    -webkit-text-size-adjust: 100%; /* 2 */
  }

/**
   * Remove default margin.
   */

body {
    margin: 0;
  }

/* HTML5 display definitions
     ========================================================================== */

/**
   * Correct \`block\` display not defined for any HTML5 element in IE 8/9.
   * Correct \`block\` display not defined for \`details\` or \`summary\` in IE 10/11
   * and Firefox.
   * Correct \`block\` display not defined for \`main\` in IE 11.
   */

article, aside, details, figcaption, figure, footer, header, hgroup, main, menu, nav, section, summary {
    display: block;
  }

/**
   * 1. Correct \`inline-block\` display not defined in IE 8/9.
   * 2. Normalize vertical alignment of \`progress\` in Chrome, Firefox, and Opera.
   */

audio, canvas, progress, video {
    display: inline-block; /* 1 */
    vertical-align: baseline; /* 2 */
  }

/**
   * Prevent modern browsers from displaying \`audio\` without controls.
   * Remove excess height in iOS 5 devices.
   */

audio:not([controls]) {
    display: none;
    height: 0;
  }

/**
   * Address \`[hidden]\` styling not present in IE 8/9/10.
   * Hide the \`template\` element in IE 8/9/11, Safari, and Firefox < 22.
   */

[hidden], template {
    display: none;
  }

/* Links
     ========================================================================== */

/**
   * Remove the gray background color from active links in IE 10.
   */

a {
    background-color: transparent;
  }

/**
   * Improve readability when focused and also mouse hovered in all browsers.
   */

a:active, a:hover {
    outline: 0;
  }

/* Text-level semantics
     ========================================================================== */

/**
   * Address styling not present in IE 8/9/10/11, Safari, and Chrome.
   */

abbr[title] {
    border-bottom: 1px dotted;
  }

/**
   * Address style set to \`bolder\` in Firefox 4+, Safari, and Chrome.
   */

b, strong {
    font-weight: bold;
  }

/**
   * Address styling not present in Safari and Chrome.
   */

dfn {
    font-style: italic;
  }

/**
   * Address variable \`h1\` font-size and margin within \`section\` and \`article\`
   * contexts in Firefox 4+, Safari, and Chrome.
   */

h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }

/**
   * Address styling not present in IE 8/9.
   */

mark {
    background: #FF0;
    color: #000;
  }

/**
   * Address inconsistent and variable font size in all browsers.
   */

small {
    font-size: 80%;
  }

/**
   * Prevent \`sub\` and \`sup\` affecting \`line-height\` in all browsers.
   */

sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

sup {
    top: -0.5em;
  }

sub {
    bottom: -0.25em;
  }

/* Embedded content
     ========================================================================== */

/**
   * Remove border when inside \`a\` element in IE 8/9/10.
   */

img {
    border: 0;
  }

/**
   * Correct overflow not hidden in IE 9/10/11.
   */

svg:not(:root) {
    overflow: hidden;
  }

/* Grouping content
     ========================================================================== */

/**
   * Address margin not present in IE 8/9 and Safari.
   */

figure {
    margin: 1em 40px;
  }

/**
   * Address differences between Firefox and other browsers.
   */

hr {
    box-sizing: content-box;
    height: 0;
  }

/**
   * Contain overflow in all browsers.
   */

pre {
    overflow: auto;
  }

/**
   * Address odd \`em\`-unit font size rendering in all browsers.
   */

code, kbd, pre, samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }

/* Forms
     ========================================================================== */

/**
   * Known limitation: by default, Chrome and Safari on OS X allow very limited
   * styling of \`select\`, unless a \`border\` property is set.
   */

/**
   * 1. Correct color not being inherited.
   *    Known issue: affects color of disabled elements.
   * 2. Correct font properties not being inherited.
   * 3. Address margins set differently in Firefox 4+, Safari, and Chrome.
   */

button, input, optgroup, select, textarea {
    color: inherit; /* 1 */
    font: inherit; /* 2 */
    margin: 0; /* 3 */
  }

/**
   * Address \`overflow\` set to \`hidden\` in IE 8/9/10/11.
   */

button {
    overflow: visible;
  }

/**
   * Address inconsistent \`text-transform\` inheritance for \`button\` and \`select\`.
   * All other form control elements do not inherit \`text-transform\` values.
   * Correct \`button\` style inheritance in Firefox, IE 8/9/10/11, and Opera.
   * Correct \`select\` style inheritance in Firefox.
   */

button, select {
    text-transform: none;
  }

/**
   * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native \`audio\`
   *    and \`video\` controls.
   * 2. Correct inability to style clickable \`input\` types in iOS.
   * 3. Improve usability and consistency of cursor style between image-type
   *    \`input\` and others.
   */

button, html input[type="button"], input[type="reset"], input[type="submit"] {
    -webkit-appearance: button; /* 2 */
    cursor: pointer; /* 3 */
  }

/**
   * Re-set default cursor for disabled elements.
   */

button[disabled], html input[disabled] {
    cursor: default;
  }

/**
   * Remove inner padding and border in Firefox 4+.
   */

button::-moz-focus-inner, input::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

/**
   * Address Firefox 4+ setting \`line-height\` on \`input\` using \`!important\` in
   * the UA stylesheet.
   */

input {
    line-height: normal;
  }

/**
   * It's recommended that you don't attempt to style these elements.
   * Firefox's implementation doesn't respect box-sizing, padding, or width.
   *
   * 1. Address box sizing set to \`content-box\` in IE 8/9/10.
   * 2. Remove excess padding in IE 8/9/10.
   */

input[type="checkbox"], input[type="radio"] {
    box-sizing: border-box; /* 1 */
    padding: 0; /* 2 */
  }

/**
   * Fix the cursor style for Chrome's increment/decrement buttons. For certain
   * \`font-size\` values of the \`input\`, it causes the cursor style of the
   * decrement button to change from \`default\` to \`text\`.
   */

input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button {
    height: auto;
  }

/**
   * 1. Address \`appearance\` set to \`searchfield\` in Safari and Chrome.
   * 2. Address \`box-sizing\` set to \`border-box\` in Safari and Chrome
   *    (include \`-moz\` to future-proof).
   */

input[type="search"] {
    -webkit-appearance: textfield; /* 1 */ /* 2 */
    box-sizing: content-box;
  }

/**
   * Remove inner padding and search cancel button in Safari and Chrome on OS X.
   * Safari (but not Chrome) clips the cancel button when the search input has
   * padding (and \`textfield\` appearance).
   */

input[type="search"]::-webkit-search-cancel-button, input[type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }

/**
   * Define consistent border, margin, and padding.
   */

fieldset {
    border: 1px solid #C0C0C0;
    margin: 0 2px;
    padding: 0.35em 0.625em 0.75em;
  }

/**
   * 1. Correct \`color\` not being inherited in IE 8/9/10/11.
   * 2. Remove padding so people aren't caught out if they zero out fieldsets.
   */

legend {
    border: 0; /* 1 */
    padding: 0; /* 2 */
  }

/**
   * Remove default vertical scrollbar in IE 8/9/10/11.
   */

textarea {
    overflow: auto;
  }

/**
   * Don't inherit the \`font-weight\` (applied by a rule above).
   * NOTE: the default cannot safely be changed in Chrome and Safari on OS X.
   */

optgroup {
    font-weight: bold;
  }

/* Tables
     ========================================================================== */

/**
   * Remove most spacing between table cells.
   */

table {
    border-collapse: collapse;
    border-spacing: 0;
  }

td, th {
    padding: 0;
  }
`, "",{"version":3,"sources":["webpack://./universal/styles/vendor/normalize.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D;;;;CAIC;;AAmOG;IAAA,sBAAiC;IAAjC,kBAAiC;IAAjC,gBAAiC;IAAjC;AAAiC;;AAAjC;IAAA,sBAAiC;IAAjC,kBAAiC;IAAjC,gBAAiC;IAAjC;AAAiC;;AAAjC;IAAA,sBAAiC;IAAjC,kBAAiC;IAAjC,gBAAiC;IAAjC;AAAiC;;AAAjC;IAAA,sBAAiC;IAAjC,kBAAiC;IAAjC,gBAAiC;IAAjC;AAAiC;;AA/NjC;IAAA,uBAAuB;IAAvB,kBAAuB;IAAvB,gBAAuB;IAAvB;AAAuB;;AAAvB;IAAA,uBAAuB;IAAvB,kBAAuB;IAAvB,gBAAuB;IAAvB;AAAuB;;AAAvB;IAAA,uBAAuB;IAAvB,kBAAuB;IAAvB,gBAAuB;IAAvB;AAAuB;;AAAvB;IAAA,uBAAuB;IAAvB,kBAAuB;IAAvB,gBAAuB;IAAvB;AAAuB;;AAAvB;IAAA,uBAAuB;IAAvB,kBAAuB;IAAvB,gBAAuB;IAAvB;AAAuB;;AAAvB;IAAA,uBAAuB;IAAvB,kBAAuB;IAAvB,gBAAuB;IAAvB;AAAuB;;AADzB;IACE,uBAAuB,EAAE,MAAM;IAC/B,0BAA0B,EAAE,MAAM;IAClC,8BAA8B,EAAE,MAAM;EACxC;;AAEA;;IAEE;;AAEF;IACE,SAAS;EACX;;AAEA;iFAC+E;;AAE/E;;;;;IAKE;;AAEF;IAaE,cAAc;EAChB;;AAEA;;;IAGE;;AAEF;IAIE,qBAAqB,EAAE,MAAM;IAC7B,wBAAwB,EAAE,MAAM;EAClC;;AAEA;;;IAGE;;AAEF;IACE,aAAa;IACb,SAAS;EACX;;AAEA;;;IAGE;;AAEF;IAEE,aAAa;EACf;;AAEA;iFAC+E;;AAE/E;;IAEE;;AAEF;IACE,6BAA6B;EAC/B;;AAEA;;IAEE;;AAEF;IAEE,UAAU;EACZ;;AAEA;iFAC+E;;AAE/E;;IAEE;;AAEF;IACE,yBAAyB;EAC3B;;AAEA;;IAEE;;AAEF;IAEE,iBAAiB;EACnB;;AAEA;;IAEE;;AAEF;IACE,kBAAkB;EACpB;;AAEA;;;IAGE;;AAEF;IACE,cAAc;IACd,gBAAgB;EAClB;;AAEA;;IAEE;;AAEF;IACE,gBAAgB;IAChB,WAAW;EACb;;AAEA;;IAEE;;AAEF;IACE,cAAc;EAChB;;AAEA;;IAEE;;AAEF;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAC1B;;AAEA;IACE,WAAW;EACb;;AAEA;IACE,eAAe;EACjB;;AAEA;iFAC+E;;AAE/E;;IAEE;;AAEF;IACE,SAAS;EACX;;AAEA;;IAEE;;AAEF;IACE,gBAAgB;EAClB;;AAEA;iFAC+E;;AAE/E;;IAEE;;AAEF;IACE,gBAAgB;EAClB;;AAEA;;IAEE;;AAEF;IAEE,uBAAuB;IACvB,SAAS;EACX;;AAEA;;IAEE;;AAEF;IACE,cAAc;EAChB;;AAEA;;IAEE;;AAEF;IAIE,iCAAiC;IACjC,cAAc;EAChB;;AAEA;iFAC+E;;AAE/E;;;IAGE;;AAEF;;;;;IAKE;;AAEF;IAKE,cAAc,EAAE,MAAM;IACtB,aAAa,EAAE,MAAM;IACrB,SAAS,EAAE,MAAM;EACnB;;AAEA;;IAEE;;AAEF;IACE,iBAAiB;EACnB;;AAEA;;;;;IAKE;;AAEF;IAEE,oBAAoB;EACtB;;AAEA;;;;;;IAME;;AAEF;IAIE,0BAA0B,EAAE,MAAM;IAClC,eAAe,EAAE,MAAM;EACzB;;AAEA;;IAEE;;AAEF;IAEE,eAAe;EACjB;;AAEA;;IAEE;;AAEF;IAEE,SAAS;IACT,UAAU;EACZ;;AAEA;;;IAGE;;AAEF;IACE,mBAAmB;EACrB;;AAEA;;;;;;IAME;;AAEF;IAEE,sBAAsB,EAAE,MAAM;IAC9B,UAAU,EAAE,MAAM;EACpB;;AAEA;;;;IAIE;;AAEF;IAEE,YAAY;EACd;;AAEA;;;;IAIE;;AAEF;IACE,6BAA6B,EAAE,MAAM,EAEJ,MAAM;IACvC,uBAAuB;EACzB;;AAEA;;;;IAIE;;AAEF;IAEE,wBAAwB;EAC1B;;AAEA;;IAEE;;AAEF;IACE,yBAAyB;IACzB,aAAa;IACb,8BAA8B;EAChC;;AAEA;;;IAGE;;AAEF;IACE,SAAS,EAAE,MAAM;IACjB,UAAU,EAAE,MAAM;EACpB;;AAEA;;IAEE;;AAEF;IACE,cAAc;EAChB;;AAEA;;;IAGE;;AAEF;IACE,iBAAiB;EACnB;;AAEA;iFAC+E;;AAE/E;;IAEE;;AAEF;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;AAEA;IAEE,UAAU;EACZ","sourcesContent":["/*! normalize.css v3.0.2 | MIT License | git.io/normalize */\n\n/**\n* 1. Set default font family to sans-serif.\n* 2. Prevent iOS text size adjust after orientation change, without disabling\n*    user zoom.\n*/\n\n:global {\n  html {\n    font-family: sans-serif; /* 1 */\n    -ms-text-size-adjust: 100%; /* 2 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n  }\n\n  /**\n   * Remove default margin.\n   */\n\n  body {\n    margin: 0;\n  }\n\n  /* HTML5 display definitions\n     ========================================================================== */\n\n  /**\n   * Correct `block` display not defined for any HTML5 element in IE 8/9.\n   * Correct `block` display not defined for `details` or `summary` in IE 10/11\n   * and Firefox.\n   * Correct `block` display not defined for `main` in IE 11.\n   */\n\n  article,\n  aside,\n  details,\n  figcaption,\n  figure,\n  footer,\n  header,\n  hgroup,\n  main,\n  menu,\n  nav,\n  section,\n  summary {\n    display: block;\n  }\n\n  /**\n   * 1. Correct `inline-block` display not defined in IE 8/9.\n   * 2. Normalize vertical alignment of `progress` in Chrome, Firefox, and Opera.\n   */\n\n  audio,\n  canvas,\n  progress,\n  video {\n    display: inline-block; /* 1 */\n    vertical-align: baseline; /* 2 */\n  }\n\n  /**\n   * Prevent modern browsers from displaying `audio` without controls.\n   * Remove excess height in iOS 5 devices.\n   */\n\n  audio:not([controls]) {\n    display: none;\n    height: 0;\n  }\n\n  /**\n   * Address `[hidden]` styling not present in IE 8/9/10.\n   * Hide the `template` element in IE 8/9/11, Safari, and Firefox < 22.\n   */\n\n  [hidden],\n  template {\n    display: none;\n  }\n\n  /* Links\n     ========================================================================== */\n\n  /**\n   * Remove the gray background color from active links in IE 10.\n   */\n\n  a {\n    background-color: transparent;\n  }\n\n  /**\n   * Improve readability when focused and also mouse hovered in all browsers.\n   */\n\n  a:active,\n  a:hover {\n    outline: 0;\n  }\n\n  /* Text-level semantics\n     ========================================================================== */\n\n  /**\n   * Address styling not present in IE 8/9/10/11, Safari, and Chrome.\n   */\n\n  abbr[title] {\n    border-bottom: 1px dotted;\n  }\n\n  /**\n   * Address style set to `bolder` in Firefox 4+, Safari, and Chrome.\n   */\n\n  b,\n  strong {\n    font-weight: bold;\n  }\n\n  /**\n   * Address styling not present in Safari and Chrome.\n   */\n\n  dfn {\n    font-style: italic;\n  }\n\n  /**\n   * Address variable `h1` font-size and margin within `section` and `article`\n   * contexts in Firefox 4+, Safari, and Chrome.\n   */\n\n  h1 {\n    font-size: 2em;\n    margin: 0.67em 0;\n  }\n\n  /**\n   * Address styling not present in IE 8/9.\n   */\n\n  mark {\n    background: #FF0;\n    color: #000;\n  }\n\n  /**\n   * Address inconsistent and variable font size in all browsers.\n   */\n\n  small {\n    font-size: 80%;\n  }\n\n  /**\n   * Prevent `sub` and `sup` affecting `line-height` in all browsers.\n   */\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  /* Embedded content\n     ========================================================================== */\n\n  /**\n   * Remove border when inside `a` element in IE 8/9/10.\n   */\n\n  img {\n    border: 0;\n  }\n\n  /**\n   * Correct overflow not hidden in IE 9/10/11.\n   */\n\n  svg:not(:root) {\n    overflow: hidden;\n  }\n\n  /* Grouping content\n     ========================================================================== */\n\n  /**\n   * Address margin not present in IE 8/9 and Safari.\n   */\n\n  figure {\n    margin: 1em 40px;\n  }\n\n  /**\n   * Address differences between Firefox and other browsers.\n   */\n\n  hr {\n    -moz-box-sizing: content-box;\n    box-sizing: content-box;\n    height: 0;\n  }\n\n  /**\n   * Contain overflow in all browsers.\n   */\n\n  pre {\n    overflow: auto;\n  }\n\n  /**\n   * Address odd `em`-unit font size rendering in all browsers.\n   */\n\n  code,\n  kbd,\n  pre,\n  samp {\n    font-family: monospace, monospace;\n    font-size: 1em;\n  }\n\n  /* Forms\n     ========================================================================== */\n\n  /**\n   * Known limitation: by default, Chrome and Safari on OS X allow very limited\n   * styling of `select`, unless a `border` property is set.\n   */\n\n  /**\n   * 1. Correct color not being inherited.\n   *    Known issue: affects color of disabled elements.\n   * 2. Correct font properties not being inherited.\n   * 3. Address margins set differently in Firefox 4+, Safari, and Chrome.\n   */\n\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    color: inherit; /* 1 */\n    font: inherit; /* 2 */\n    margin: 0; /* 3 */\n  }\n\n  /**\n   * Address `overflow` set to `hidden` in IE 8/9/10/11.\n   */\n\n  button {\n    overflow: visible;\n  }\n\n  /**\n   * Address inconsistent `text-transform` inheritance for `button` and `select`.\n   * All other form control elements do not inherit `text-transform` values.\n   * Correct `button` style inheritance in Firefox, IE 8/9/10/11, and Opera.\n   * Correct `select` style inheritance in Firefox.\n   */\n\n  button,\n  select {\n    text-transform: none;\n  }\n\n  /**\n   * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n   *    and `video` controls.\n   * 2. Correct inability to style clickable `input` types in iOS.\n   * 3. Improve usability and consistency of cursor style between image-type\n   *    `input` and others.\n   */\n\n  button,\n  html input[type=\"button\"], /* 1 */\n  input[type=\"reset\"],\n  input[type=\"submit\"] {\n    -webkit-appearance: button; /* 2 */\n    cursor: pointer; /* 3 */\n  }\n\n  /**\n   * Re-set default cursor for disabled elements.\n   */\n\n  button[disabled],\n  html input[disabled] {\n    cursor: default;\n  }\n\n  /**\n   * Remove inner padding and border in Firefox 4+.\n   */\n\n  button::-moz-focus-inner,\n  input::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n  }\n\n  /**\n   * Address Firefox 4+ setting `line-height` on `input` using `!important` in\n   * the UA stylesheet.\n   */\n\n  input {\n    line-height: normal;\n  }\n\n  /**\n   * It's recommended that you don't attempt to style these elements.\n   * Firefox's implementation doesn't respect box-sizing, padding, or width.\n   *\n   * 1. Address box sizing set to `content-box` in IE 8/9/10.\n   * 2. Remove excess padding in IE 8/9/10.\n   */\n\n  input[type=\"checkbox\"],\n  input[type=\"radio\"] {\n    box-sizing: border-box; /* 1 */\n    padding: 0; /* 2 */\n  }\n\n  /**\n   * Fix the cursor style for Chrome's increment/decrement buttons. For certain\n   * `font-size` values of the `input`, it causes the cursor style of the\n   * decrement button to change from `default` to `text`.\n   */\n\n  input[type=\"number\"]::-webkit-inner-spin-button,\n  input[type=\"number\"]::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /**\n   * 1. Address `appearance` set to `searchfield` in Safari and Chrome.\n   * 2. Address `box-sizing` set to `border-box` in Safari and Chrome\n   *    (include `-moz` to future-proof).\n   */\n\n  input[type=\"search\"] {\n    -webkit-appearance: textfield; /* 1 */\n    -moz-box-sizing: content-box;\n    -webkit-box-sizing: content-box; /* 2 */\n    box-sizing: content-box;\n  }\n\n  /**\n   * Remove inner padding and search cancel button in Safari and Chrome on OS X.\n   * Safari (but not Chrome) clips the cancel button when the search input has\n   * padding (and `textfield` appearance).\n   */\n\n  input[type=\"search\"]::-webkit-search-cancel-button,\n  input[type=\"search\"]::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /**\n   * Define consistent border, margin, and padding.\n   */\n\n  fieldset {\n    border: 1px solid #C0C0C0;\n    margin: 0 2px;\n    padding: 0.35em 0.625em 0.75em;\n  }\n\n  /**\n   * 1. Correct `color` not being inherited in IE 8/9/10/11.\n   * 2. Remove padding so people aren't caught out if they zero out fieldsets.\n   */\n\n  legend {\n    border: 0; /* 1 */\n    padding: 0; /* 2 */\n  }\n\n  /**\n   * Remove default vertical scrollbar in IE 8/9/10/11.\n   */\n\n  textarea {\n    overflow: auto;\n  }\n\n  /**\n   * Don't inherit the `font-weight` (applied by a rule above).\n   * NOTE: the default cannot safely be changed in Chrome and Safari on OS X.\n   */\n\n  optgroup {\n    font-weight: bold;\n  }\n\n  /* Tables\n     ========================================================================== */\n\n  /**\n   * Remove most spacing between table cells.\n   */\n\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n\n  td,\n  th {\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
